import DefaultAttr from './default'
export default class Clock extends DefaultAttr {
  clockParams = {
    /**
     * 0、number
     * 1、date
     * 2、dateTime
     * 3、clock
     * */
    styleType: ''
  }
  constructor (args = {}) {
    super(args)
    this._.assign(this, args)
    // 挂载背景颜色
    this.setStyleSetting(args.type, this)
  }
}



// WEBPACK FOOTER //
// ./src/components/report/design/customPage/assets/js/clock.js